module.exports = __webpack_public_path__ + "static/img/S2.9bfad43c.png";